import { useFormContext } from 'react-hook-form'
import type { PersonelFormValues } from '../schemas/personelFormSchema'

export function useFieldError() {
  const { formState } = useFormContext<PersonelFormValues>()
  return (name: keyof PersonelFormValues) => {
    const msg = formState.errors[name]?.message
    return msg ? String(msg) : undefined
  }
}
